import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { ConsumablesCategoriesRedux } from '../Redux/ConsumablesCategoriesRedux'

const consumablesCategoriesCRUDObservable = createCRUDObservable({
  mainRedux: ConsumablesCategoriesRedux,
  reduxPath: 'consumables_categories',
})

export const consumablesCategoriesObservers = Object.assign({},
  consumablesCategoriesCRUDObservable.observers, {
  })

export const consumablesCategoriesEpic = combineEpics(
  consumablesCategoriesCRUDObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ConsumablesCategoriesObservable.js